import React, { FC } from "react";
import { IconButton, ThemeName } from "@evergis/ui";

import { MapControlContainer } from "../styled";
import { ThemeProvider } from "../../../components/ThemeProvider";
import { useMapViewHistoryState, useMapViewUndoRedo } from "../../../ducks/mapView/useMapView";
import { useSharedProjectHomeView } from "../hooks/useSharedProjectHomeView";

export const BookmarkControl: FC = () => {
  const { undo, redo } = useMapViewUndoRedo();
  const { canRedo, canUndo } = useMapViewHistoryState();
  const goToHome = useSharedProjectHomeView();

  return (
    <ThemeProvider themeName={ThemeName.Dark}>
      <MapControlContainer withPadding>
        <IconButton disabled={!canUndo} title={"Вид карты по умолчанию"} kind={"home"} onClick={goToHome} />
        <IconButton disabled={!canUndo} title={"Предыдущая область"} kind={"arrow_back"} onClick={undo} />
        <IconButton disabled={!canRedo} title={"Следующая область"} kind={"arrow_forward"} onClick={redo} />
      </MapControlContainer>
    </ThemeProvider>
  );
};
